import { render } from "./knowledgeGraph.vue?vue&type=template&id=129735a9&scoped=true"
import script from "./knowledgeGraph.vue?vue&type=script&lang=js"
export * from "./knowledgeGraph.vue?vue&type=script&lang=js"

import "./knowledgeGraph.vue?vue&type=style&index=0&id=129735a9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129735a9"]])

export default __exports__